const customTypes = {}

export default customTypes

/**
 *
 * @param {*} customOption
 */
export const getCustomOptionTypeComponent = () => {}
